class Controller {
  constructor(City, Events) {
    "ngInject";

    this.City = City;
    this.Events = Events;
    this.errorNotificationEvent = this.Events.eventsType.onShowErrorNotification;
    this.successNotificationEvent = this.Events.eventsType.onShowSuccessNotification;
    this.isDisabled = true;
    this.takenOptions = {};

    this.updatePaymentMethods = this.updatePaymentMethods.bind(this);
  }

  $onInit() {
    this.City.getAppliedPaymentMethods(this.cityId, {
      isCityRequired: false,
      active: true,
    }).$promise.then(
      (response) => {
        this.cityPaymentMethods = response;
        this.getApplicablePaymentMethods();
      },
      (response) => this.Events.emit(this.errorNotificationEvent, response.data)
    );
  }

  getApplicablePaymentMethods() {
    this.City.getApplicablePaymentMethods(this.cityId, {
      isCityRequired: false,
    }).$promise.then(
      (response) => {
        this.cityApplicablePaymentMethods = response;
        this.cityPaymentMethods.forEach(({ _id }) => this.applyTaken(_id));
      },
      (response) => this.Events.emit(this.errorNotificationEvent, response.data)
    );
  }

  applyTaken(newValId, oldValId) {
    if (oldValId) this.takenOptions[oldValId] = false;
    this.takenOptions[newValId] = true;
  }

  isOptionDifferentAndTaken(methodId, optionId) {
    return methodId !== optionId && this.takenOptions[optionId];
  }

  addPaymentMethod() {
    if (!Array.isArray(this.cityPaymentMethods)) this.cityPaymentMethods = [];

    this.cityPaymentMethods.push({
      active: false,
      is_editable: true,
      new: true,
    });
  }

  removePaymentMethod(index, methodId) {
    this.cityPaymentMethods.splice(index, 1);
    this.takenOptions[methodId] = false;
  }

  updatePaymentMethods() {
    const paymentMethods = this.cityPaymentMethods.map(({ _id, active }) => ({
      _id,
      active,
    }));
    this.City.updatePaymentMethods(this.cityId, paymentMethods).$promise.then(
      (response) => {
        this.isDisabled = true;
        this.cityPaymentMethods = response;
        this.Events.emit(this.successNotificationEvent, {
          message: "Payment Methods are updated successfully",
        });
      },
      (response) => this.Events.emit(this.errorNotificationEvent, response.data)
    );
  }
}

export default Controller;



// WEBPACK FOOTER //
// ./src/components/cityPaymentMethods/cityPaymentMethods.controller.js